import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Language, LanguageService } from '../services/language.service';
import { PublicAvailabilitiesListComponent } from './public-availabilities-list.component';
import { PublicLoadsListComponent } from './public-loads-list.component';
import { PwaInstallService } from '../services/pwa-install.service';

type PublicMarketplaceTab = 'loads' | 'availability';

@Component({
  selector: 'app-public-marketplace',
  standalone: true,
  imports: [CommonModule, RouterLink, PublicLoadsListComponent, PublicAvailabilitiesListComponent],
  templateUrl: './public-marketplace.component.html',
  styleUrls: ['./public-marketplace.shared.css']
})
export class PublicMarketplaceComponent {
  private readonly router = inject(Router);
  readonly languageService = inject(LanguageService);
  readonly pwaInstall = inject(PwaInstallService);

  activeTab: PublicMarketplaceTab = 'loads';

  selectTab(tab: PublicMarketplaceTab): void {
    this.activeTab = tab;
  }

  login(): void {
    this.router.navigate(['/login'], {
      queryParams: { returnUrl: this.router.url || '/' }
    });
  }

  setLanguage(language: Language): void {
    this.languageService.setLanguage(language);
  }

  async installApp(): Promise<void> {
    await this.pwaInstall.promptInstall();
  }

  text(en: string, ar: string): string {
    return this.languageService.currentLanguage() === 'ar' ? ar : en;
  }
}
